<header class="fixed-top">
  <nav class="navbar navbar-light">
    <a class="navbar-brand">NLW VALORIZA</a>
    <div *ngIf="(user$ | async) as user; else login">
      <i class="fa fa-user-circle mr-1"></i>
      <a class="mr-1">{{ user.name }}</a>
      <a (click)="logout()" style="cursor: pointer;">(Logout)</a>
    </div>

    <ng-template #login>
      <span class="navbar-text">
        <a [routerLink]="['']">Please, login!</a>
      </span>
    </ng-template>
  </nav>
</header>
